import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "@firebase/auth";

const firebaseConfig = {
        apiKey: "AIzaSyBH1L-T3hVn6yo0aUxF3SkcIB_ZhZM6lRc",
        authDomain: "pickem-3a187.firebaseapp.com",
        databaseURL: "https://pickem-3a187-default-rtdb.firebaseio.com",
        projectId: "pickem-3a187",
        storageBucket: "pickem-3a187.appspot.com",
        messagingSenderId: "160869549397",
        appId: "1:160869549397:web:444ff75c47b798871ddbdc",
        measurementId: "G-S5CCX7XVQ1"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export default function StartFirebase() {        
    return getDatabase(app);
}


//export default StartFirebase;
//const config = {
//  apiKey: "AIzaSyAgBvGKlPEySB6vCWVkyO5OnRiVP3pzgps",
//  authDomain: "react-firebase-basic.firebaseapp.com",
//  databaseURL: "https://react-firebase-basic.firebaseio.com"
//};

